<template>
  <div id="home">
    <div id="wrap">
      <div><img src="img/1.png" alt=""></div>
      <div><img src="img/about.jpg" alt=""></div>
      <div id="tag">
        <div @click="goToPage('ch')"><img src="img/2-1.png"></div>
        <div><img src="img/2-2.png"></div>
        <div @click="goToPage('en')"><img src="img/2-3.png"></div>
      </div>
      <div><img src="img/beianhao.jpg" alt=""></div>

      <div id="footer"></div>
      <a class="text-dark" href="https://beian.miit.gov.cn/">粤ICP备06050840号-1</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    goToPage(type) {
      this.$router.push("/home")
      localStorage.setItem("curlanguage", type)
    }
  },
  created() { },
  mounted() { }
}
</script>

<style scoped>
#home {
  width: 100%;
}

#wrap {
  width: 1100px;
  margin: 0 auto;
}

#tag {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

#footer {
  height: 30px;
  background: #838383;

  margin: 0 auto;
}

a {
  text-decoration: none;
}

.text-dark {
  display: inline-block;
  margin-top: 6px;
  float: left;
}
</style>